import { render } from "./Linkedin.vue?vue&type=template&id=36dbde0b"
import script from "./Linkedin.vue?vue&type=script&lang=js"
export * from "./Linkedin.vue?vue&type=script&lang=js"
script.render = render

export default script